import type {CopilotChatReference} from '@github-ui/copilot-chat-types'
import type {MessageAttachment} from '@microsoft/agent-host-protocol'
import {createContext, use, type MouseEvent} from 'react'

export interface ReferenceImage {
  id?: string
  name: string
  alt?: string
  src: string
  contentType?: string
}

export type ReferenceActivation =
  | {kind: 'reference'; reference: CopilotChatReference}
  | {kind: 'attachment'; attachment: MessageAttachment; id?: string}
  | {kind: 'image'; image: ReferenceImage}
  | {kind: 'space'; owner: string; number: number}

/** Return false to preserve the surface's ordinary link or image-dialog fallback. */
export type ReferenceActivationHandler = (target: ReferenceActivation, event?: MouseEvent) => boolean

/** Only an eligible workbench host installs this optional preview capability. */
export const ReferenceActivationContext = createContext<ReferenceActivationHandler | null>(null)

export function useReferenceActivation() {
  return use(ReferenceActivationContext)
}
